@if (usePopover()) {
  <button
    type="button"
    [class]="
      'common-selector fill grow ps-small align-left rounded-large white-bg surface-primary ' +
      hoverClasses() +
      (position() ? ' position-' + position() : '')
    "
    [class.filled]="filled()"
    [attr.aria-label]="ariaLabel()"
    [attr.aria-disabled]="disabled()"
    [disabled]="disabled()"
    fcomPopover
    [content]="popoverContent()"
    [options]="popoverOptions()"
    (popoverClosed)="handlePopoverClose()"
    data-testid="booking-widget-selector-popover"
  >
    <ng-container *ngTemplateOutlet="content" />
  </button>
} @else {
  <button
    type="button"
    [class]="
      'common-selector selector-modal fill grow ps-small align-left rounded-large white-bg surface-primary ' +
      hoverClasses() +
      (position() ? ' position-' + position() : '')
    "
    [class.filled]="filled()"
    [attr.aria-label]="ariaLabel()"
    [attr.aria-disabled]="disabled()"
    [disabled]="disabled()"
    data-testid="booking-widget-selector-modal"
  >
    <ng-container *ngTemplateOutlet="content" />
  </button>
}

<ng-template #content>
  @if (!double()) {
    <div class="flex flex--column flex--left-center">
      <ng-container
        *ngTemplateOutlet="selectorTemplate; context: { label: label(), placeholder: placeholder(), filled: filled() }"
      />
      <div class="nordic-blue-900-text text-icon-primary font-label-medium">
        <ng-content />
      </div>
    </div>
  }

  @if (double()) {
    <div class="flex flex--row double">
      <div class="flex-1 flex flex--column flex--basis-half">
        <ng-container *ngTemplateOutlet="selectorTemplate; context: double().first" />
        <div class="nordic-blue-900-text text-icon-primary font-label-medium">
          <ng-content select="[first]" />
        </div>
      </div>
      <ng-content select="[separator]" />
      <div class="flex-1 flex flex--column flex--basis-half second-half">
        <ng-container *ngTemplateOutlet="selectorTemplate; context: double().second" />
        <div class="nordic-blue-900-text text-icon-primary font-label-medium">
          <ng-content select="[second]" />
        </div>
      </div>
    </div>
  }
</ng-template>

<ng-template #selectorTemplate let-label="label" let-placeholder="placeholder" let-filled="filled">
  <span class="blue-600-text flex-1 font-body-medium" data-testid="common-selector-label">{{ label }}</span>
  <span
    class="grey-600-text text-icon-disabled-text flex-1 font-label-medium"
    [class.is-hidden]="filled"
    data-testid="common-selector-placeholder"
  >
    {{ placeholder }}
  </span>
</ng-template>
